import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/miniprogramAdvertisementManage',
  name: 'advertiseSpaceSet',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/miniprogramAdvertisementManage',
      component: () => import('@/views/operation/miniprogramAdvertisementManage/index.vue'),
      meta: {
        title: '小程序广告位设置',
        icon: 'ad'
      }
    },
    {
      path: '/operation/miniprogramAdvertisementManage/:groupId',
      component: () => import('@/views/operation/news'),
      meta: {
        title: '小程序位详情'
      }
    }
  ]
}
